import React from "react";

class Title extends React.Component {


  render() {
      const {introTitle} = this.props;
    return (
      <section className={"rob-title"}>
          <div className="container">
              <div className="row">
                  <div className="col-md-12">
                      <div className={"rob-title__wrapper"}>
                      <h1>{introTitle}</h1>
                      </div>
                  </div>
              </div>
          </div>
      </section>
    )
  }
}

export default Title;




// WEBPACK FOOTER //
// ./src/components/elements/Title.js